// The message to show for a failed API call: the server's own wording when it
// sent one (`error`, or `message` from handlers that answer with that key),
// the transport error otherwise, then the caller's fallback.
export function apiErrorMessage(error, fallback) {
  const data = error?.response?.data
  return data?.error || data?.message || error?.message || fallback || String(error)
}
